module.exports = __webpack_public_path__ + "static/img/H2O.607577ba.png";